import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from "moment/moment";

@Injectable({ providedIn: 'root' })
export class WithdrawFundsFormProvider {
  investmentForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  initWithdrawFundsForm(data?: any): FormGroup {
    return (this.investmentForm = this.fb.group({
      investorId: [data?.investorId, [Validators.required]],
      intermediaryId: [data?.intermediaryId],
      type: [data?.type || '', [Validators.required]],
      transactionType: ['Redemption'],
      date: [data?.date || moment().format('YYYY-MM-DD'), [Validators.required]],
      faceValue: [+data?.faceValue || '', [Validators.required, Validators.min(0.01)]],
      product: [data?.product || '', [Validators.required]],
      ccy: [data?.ccy || ''],
      fullRedemption: [data?.fullRedemption || false],
    }));
  }
}
